import { api } from '@/shared/lib/api'
import type { LoginResponse, User } from '../types'

export const authService = {
  /**
   * POST /login/ — credentials sent as query params (backend reads from query, not body)
   * expiration_hours=999 effectively means "don't expire"
   */
  login: async (emailRut: string, password: string): Promise<LoginResponse> => {
    const { data } = await api.post<LoginResponse>('/login/', null, {
      params: {
        rut_or_email: emailRut,
        password,
        expiration_hours: 999,
      },
    })
    return data
  },

  /**
   * GET /users/{id} — verify the stored token is still valid
   * Used on app startup to rehydrate the auth state
   */
  getCurrentUser: async (userId: number): Promise<User> => {
    const { data } = await api.get<User>(`/users/${userId}`)
    return data
  },
}
